import SOCKET_NAMESPACES from 'socket-resources/namespaces/index'

export const WALLET_USER_WALLET_BALANCE = `${SOCKET_NAMESPACES.WALLET}/userWalletBalance`